<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-back`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.56644 4.02905C7.30679 3.76963 6.88468 3.7696 6.62504 4.02905L3.12504 7.52905C2.86541 7.78867 2.86556 8.21074 3.12504 8.47045L6.62504 11.9705L6.72953 12.0554C6.98766 12.2259 7.33918 12.1977 7.56644 11.9705C7.79355 11.7432 7.82187 11.3916 7.65141 11.1335L7.56644 11.029L5.20219 8.66479H12.4043C12.7716 8.66479 13.0694 8.36702 13.0694 7.99975C13.0692 7.63266 12.7715 7.33471 12.4043 7.33471H5.20219L7.56644 4.97045C7.82596 4.71074 7.82608 4.28869 7.56644 4.02905Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineBack',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
